module.exports = __webpack_public_path__ + "static/sample-projects-18-1d9499d5ab74dbb8921b4ef06358d26b.png";